





























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { AssetVersion } from "@/psychlab/types/assets";
import { Graph } from "@/psychlab/types/graph";
import * as AssetAPI from "@/services/api/assets";
import * as AppModal from "@/AppModal";
// local
import { getUpdateReport } from "./getUpdateReport";
import { UpdateReport } from "./UpdateReport";

import { useTranslate } from "@lang";
import { Icon } from "@ui";

export default defineComponent({
	emit:[
		"updated",
	],
	props:{
		assetId:{
			type:String,
			required:true,
		}
	},
	components:{
		Icon,
	},
	setup(props, context){

		const loading = ref(false);
		
		const version = ref<AssetVersion<Graph>>();

		const report = ref<UpdateReport>();

		const { translate } = useTranslate();

		const data = computed(() => version.value?.data);

		const entryCount = computed(() => {
			return report.value?.entries.length || 0;
		});

		const getReportDescription = () => {
			if(!report.value){ return ""; }
			let s = "";
			report.value.entries.forEach(e => {
				s += `<li>${e.description}</li>`;
			});
			return `<ul>${s}</ul>`
		};

		const refreshReport = async () => {
			if(!data.value){ return; }
			loading.value = true;
			try {
				report.value = await getUpdateReport(data.value);
			}
			catch{}
			loading.value = false;
		};

		const refresh = async () => {
			loading.value = true;
			try {
				version.value = await AssetAPI.getAssetVersion(props.assetId, "latest", "+data");
			}
			catch(err){
				console.log(err.message);
			}
			loading.value = false;
			refreshReport();
		};

		const applyUpdate = async () => {
			if(!version.value || !data.value || !report.value || !report.value.entries.length){ return; }
			loading.value = true;
			try {
				await Promise.all(report.value.entries.map(e => e.handler()));
				const nv = await AssetAPI.saveAssetVersion(props.assetId, {
					data:data.value,
					base:version.value._id,
				});
				context.emit("updated");
				refresh();
			}
			catch{}
			loading.value = false;
		};

		const update = () => {
			AppModal.confirm({
				title:translate("assets.label.updateReferences"),
				description:getReportDescription(),
				okText:translate("assets.action.updateAll"),
				size:"md",
				cancelText:translate("prompts.action.cancel"),
				variant:"info",
				noCenterDescription:true,
			}, applyUpdate);
		};
		
		refresh();

		return {
			report,
			entryCount,
			update,
			translate,
			loading,
		};
	}
});

